import { useApp } from 'context/app-context'
import classNames from 'helpers/class-names'
import md5 from 'js-md5'
import { FC } from 'react'

interface Props {
  email: string
  className?: string
}

const UserAvatar: FC<Props> = ({ email = '', className }) => {
  const { env } = useApp()
  let [user, domain] = email.toLowerCase().split('@')
  let [sanitizedUser] = user.split('+')

  return (
    <div
      className={classNames(
        'relative h-6 w-6 overflow-hidden rounded-full',
        className,
      )}>
      <div
        className="absolute left-0 top-0 h-full w-full bg-cover"
        style={{
          backgroundImage: `url('https://www.gravatar.com/avatar/${md5(
            `${sanitizedUser}@${domain}`,
          )}?s=400&d=${env.CDN_URL}/images/users/default.png`,
        }}
      />
    </div>
  )
}

export default UserAvatar
